import {
  EMAIL_DRAFT_CARD_MARKER,
  splitEmailDraftCard,
  type EmailDraftPayload,
} from './emailDraftPayload'
import {
  EMAIL_DRAFT_FEEDBACK_CARD_MARKER,
  splitEmailDraftFeedbackCard,
  type EmailDraftFeedbackPayload,
} from './emailDraftFeedbackPayload'
import {
  EMAIL_STAGED_DRAFT_CARD_MARKER,
  splitEmailStagedDraftCard,
  type EmailStagedDraftPayload,
} from './emailStagedDraftPayload'

export type EmailDraftCompositePayload = {
  prefix: string
  draft: EmailDraftPayload | null
  stagedDraft: EmailStagedDraftPayload | null
  feedback: EmailDraftFeedbackPayload | null
}

export function splitEmailDraftComposite(
  body: string | null | undefined,
): EmailDraftCompositePayload | null {
  if (!body) return null
  const draft = splitEmailDraftCard(body)?.payload ?? null
  const stagedDraft = splitEmailStagedDraftCard(body)?.payload ?? null
  const feedback = splitEmailDraftFeedbackCard(body)?.payload ?? null
  if (!draft && !stagedDraft && !feedback) return null
  return {
    prefix: prefixBeforeFirstEmailDraftMarker(body),
    draft,
    stagedDraft,
    feedback,
  }
}

function prefixBeforeFirstEmailDraftMarker(body: string): string {
  const indices = [
    body.indexOf(EMAIL_DRAFT_CARD_MARKER),
    body.indexOf(EMAIL_STAGED_DRAFT_CARD_MARKER),
    body.indexOf(EMAIL_DRAFT_FEEDBACK_CARD_MARKER),
  ].filter((index) => index >= 0)
  if (indices.length === 0) return ''
  return body.slice(0, Math.min(...indices)).trim()
}
